import { useState, useCallback } from "react";
import { moduleIntroKey } from './constants/storageKeys';

export function useModuleIntro(moduleKey: string): [boolean, () => void] {
  const storageKey = moduleIntroKey(moduleKey);
  const [seen, setSeen] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch { /* localStorage may be unavailable */
      return true;
    }
  });

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(storageKey, 'true');
    } catch { /* localStorage may be unavailable */ }
    setSeen(true);
  }, [storageKey]);

  return [seen, dismiss];
}
